<dcr-app-shell>
  <div slot="header"><router-outlet name="header"></router-outlet></div>

  <div class="surface-container-lowest">
    <router-outlet></router-outlet>

    <campus-portal-footer class="p-bs-3xl"></campus-portal-footer>
  </div>
</dcr-app-shell>
